import React from "react";
import { showLocalDate, tolocalDate } from "../../../utilities/functions";

const StyledDate = ({ row }) => {
  return <div>{showLocalDate(row.punchIn)}</div>;
};

export default StyledDate;
